import { useEffect } from 'react';

import { Form, Modal } from 'antd';
import { useGetMediaOfferGroupByIdQuery } from 'services';

import { useMediaActionContext } from '../Context/MediaActioncontext';
import { MEDIA_MODAL_PROPS, MEDIA_OFFER_FORM_FIELDS, MEDIA_OFFER_VALIDATE_FIELDS, mapVersionToForm } from '../helpers';

import MediaContentForm from './MediaContentForm';

/**
 * Yazarın kendi medya teklifini düzenlediği modal (madde gönderme akışı).
 *
 * Parent (madde gönderme) formuyla AYNI form instance'ını paylaşır (`Form.useFormInstance()`);
 * kendi `<Form>`'unu açmaz. Bu yüzden reset her zaman argümanlı (`MEDIA_OFFER_FORM_FIELDS`) —
 * aksi halde Madde Dosyası / Kimlik Kartı gibi parent alanları da sıfırlanır.
 *
 * Yazar akışında karar (decide) YOKTUR (spec §1.3); kaydetme yalnız revize akışına bağlıdır.
 * Grup detayı context'teki `groupId` ile çekilir, form `currentVersion`'dan doldurulur,
 * revize hedefi versiyon id'sidir (`mediaID` prop — Grill Kararı 7).
 *
 * @param {Object} props
 * @param {number|string} props.mediaID - Güncel versiyonun (currentVersion) id'si; revize hedefi
 */
function EditMediaContentModal({ mediaID }) {
  const form = Form.useFormInstance();

  const { func, states } = useMediaActionContext();
  const { groupId } = states.editTrigger;

  const { data } = useGetMediaOfferGroupByIdQuery({ id: groupId }, { skip: !groupId });

  const handleSave = () => {
    form.validateFields(MEDIA_OFFER_VALIDATE_FIELDS).then(() => {
      const values = form.getFieldsValue();
      func.handleRevise(mediaID, values, groupId);
      // Parent formla aynı instance paylaşıldığı için yalnızca modalın kendi alanları resetlenir
      // (aksi halde Madde Dosyası / Kimlik Kartı da sıfırlanır)
      form.resetFields(MEDIA_OFFER_FORM_FIELDS);
      func.handleEditStateTrigger({
        trigger: false,
        mediaID: null,
        groupId: null,
      });
    });
  };

  useEffect(() => {
    // trigger deps: aynı medya tekrar açıldığında data referansı değişmediği için
    // açılışta (trigger true) yeniden doldurulmalı (#21)
    if (data?.currentVersion && states.editTrigger.trigger) {
      // mapVersionToForm grubun tamamını alır: mediaType grup düzeyinde, geri kalanı currentVersion'da
      form.setFieldsValue(mapVersionToForm(data));
    }
  }, [data, states.editTrigger.trigger, form]);

  return (
    <Modal
      {...MEDIA_MODAL_PROPS}
      title="Medyayı Düzenle"
      open={states.editTrigger.trigger}
      onOk={handleSave}
      onCancel={() => {
        // Kapanışta yalnızca modalın kendi alanları resetlenir (parent alanları korunur)
        form.resetFields(MEDIA_OFFER_FORM_FIELDS);
        func.handleEditStateTrigger({ trigger: false, mediaID: null, groupId: null });
      }}
    >
      {/**
       * Modal, parent madde formu ile aynı instance'ı paylaşır (`form`) ama DOM'da
       * parent <form>'un DIŞINA (modal portal'ı) render edilir; bu yüzden buradaki
       * <Form layout="vertical"> iç içe <form> hatası yaratmaz ve Form.Item'lara
       * `.ant-form-vertical` hizalamasını kazandırır (SupervisorEdit ile aynı desen).
       */}
      <Form
        form={form}
        layout="vertical"
      >
        <MediaContentForm readOnlyMediaType />
      </Form>
    </Modal>
  );
}
export default EditMediaContentModal;
